import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onBeforeMount } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  HeadingDisplay,
  FilterSelect,
  BaseText
} from '@warrenbrasil/nebraska-web';

import { LineChart } from '@/modules/common/components/charts/v2';

import {
  IPerformance,
  IFilter
} from '@/modules/catalog/services/variable-income';

interface Props {
  data: IPerformance;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Performance',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: IPerformance;
};



const filters = ref(props.data.filters);
const selectedOption = ref('');

const filterOptions = computed(() => {
  return filters.value.map(formatFilterOption) || [];
});

const activeChart = computed(() => {
  const chart = props.data.chart.find(
    chart => chart.benchmark === selectedOption.value
  );

  return chart;
});

const chartSummary = computed(() => {
  const summary = activeChart.value!.summary;
  const filter = filters.value.find(
    filter => filter.value === selectedOption.value
  );

  return [
    {
      label: 'Rentabilidade',
      value: formatSummaryValue(summary.return),
      color: summaryColor(summary.return.value)
    },
    {
      label: filter!.summaryLabel,
      value: summary.benchmarkReturn.formatted,
      color: NebraskaColors.elementPrimary
    },
    {
      label: `± ${filter!.summaryLabel}`,
      value: formatSummaryValue(summary.returnComparedToBenchmark),
      color: summaryColor(summary.returnComparedToBenchmark.value)
    }
  ];
});

const portfolioData = computed(() => {
  const portfolio = activeChart.value!.axisY?.find(
    axis => axis.type === 'Portfolio'
  );

  return {
    name: portfolio?.name || '-',
    data: portfolio?.values.map(value => (value ? value.value : null)) || [],
    comparator: []
  };
});

const labels = computed(() => {
  return activeChart.value!.axisX?.[0]?.values?.map(value => value.value) || [];
});

const benchmarkData = computed(() => {
  const benchmark = activeChart.value!.axisY?.find(
    axis => axis.name === selectedOption.value
  );

  return {
    name: benchmark?.name || '-',
    data: benchmark?.values.map(value => (value ? value.value : null)) || []
  };
});

function formatFilterOption(option: IFilter) {
  return {
    value: option.value,
    label: String(option.label)
  };
}

function formatSummaryValue(data: { value: number; formatted: string }) {
  return data.value > 0 ? `+${data.formatted}` : `-${data.formatted}`;
}

function summaryColor(value: number) {
  return value > 0
    ? NebraskaColors.statusPositive
    : NebraskaColors.elementPrimary;
}

function handleChange(value: string) {
  selectedOption.value = value;
}

onBeforeMount(() => {
  selectedOption.value = props.data.filters.find(item => item.active)!.value;
});

return { __sfc: true,props, filters, selectedOption, filterOptions, activeChart, chartSummary, portfolioData, labels, benchmarkData, formatFilterOption, formatSummaryValue, summaryColor, handleChange, NebraskaColors, HeadingDisplay, FilterSelect, BaseText, LineChart }
}

})